const styles = `:host {
  --goto-dialog-z-index: 100;
}

[role=heading] {
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  --goto-icon-button-icon-color: var(--goto-text-01);
}
[role=heading] ::slotted([slot=title]) {
  margin: 0;
  font: var(--goto-heading-small);
  color: var(--goto-text-01);
}

.goto-dialog-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: var(--goto-overlay-01);
  z-index: var(--goto-dialog-z-index);
  opacity: 0;
  transform: scale(1.1);
  visibility: hidden;
  transition: var(--goto-transition-dialog-out);
}

.visible {
  opacity: 1;
  transform: scale(1);
  visibility: visible;
  transition: var(--goto-transition-dialog-in);
}

.goto-dialog {
  border-width: 1px;
  border-style: solid;
  box-sizing: border-box;
  min-height: 215px;
  max-height: calc(100vh - 96px);
  background-color: var(--goto-ui-01);
  border-radius: 4px;
  border-color: var(--goto-ui-02);
  min-width: 318px;
  width: 480px;
  max-width: calc(100vw - 96px);
  box-shadow: var(--goto-elevation-300);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.goto-dialog ::slotted([slot=actions]) {
  min-height: 76px;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  padding: 0 24px;
  --goto-button-margin: 0 4px;
}
.goto-dialog .content {
  margin: 0;
  font: var(--goto-body-medium);
  color: var(--goto-text-01);
  flex-grow: 1;
  overflow-y: auto;
  border-top: solid 1px;
  border-bottom: solid 1px;
  border-color: transparent;
  padding: 0 24px;
  overscroll-behavior: contain;
}
.goto-dialog .content.content--overflow {
  border-color: var(--goto-field-01);
}
.goto-dialog.goto-dialog--small {
  width: 400px;
}
.goto-dialog.goto-dialog--large {
  width: 640px;
}
.goto-dialog.goto-dialog--xlarge {
  width: 860px;
}
.goto-dialog.goto-dialog--fullScreen {
  border: none;
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  max-height: 100vh;
  border-radius: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform: none;
}
.goto-dialog.goto-dialog--fullScreen .content {
  border-top: solid 1px;
  border-bottom: solid 1px;
  border-color: var(--goto-neutral-150);
}`; export default styles;